const RESOURCE_NAME = '/screenshots';

export default axios => ({
    getAll(groupId, params) {
        let url = `${RESOURCE_NAME}`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        return axios.get(url, {params});
    },
    getLast(groupId, last, params) {
        let url = `${RESOURCE_NAME}/last`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        //?last/(n (sec|second|min|minute|hour|day|month)(s?))
        if (last > '') url+= `/${last}`
        return axios.get(url, {params});
    },
    get4Date(groupId, date, params) {
        let url = `${RESOURCE_NAME}/${date}`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        return axios.get(url, {params});
    },
    get4Period(groupId, from, to, params) {
        let url = `${RESOURCE_NAME}/${from}/${to}`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        return axios.get(url, {params});
    },
    getLastSuccessful(groupId, params) {
        let url = `${RESOURCE_NAME}/last-successful`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        return axios.get(url, {params});
    },
    getStatistics(groupId, params) {
        let url = `${RESOURCE_NAME}/statistics`
        if (groupId > '') url = `/unit-group/${groupId}`+url
        return axios.get(url, {params});
    },
});